export default {
  SettingOrderSourceDeploy: {
    tab1: 'Sourcing Failure Settings',
    tab2: 'Allocate Logistics',
    sourcing: 'Sourcing Failure Processing',
    stockOut: 'Out Of Stock',
    reSource: 'Re-sourcing',
    manual: 'Manual Processing',
    resourceInterval: 'Re-sourcing Interval',
    resources: 'Re-sourcing Times',
    resourcesText: 'Please select the number of re-sourcing times',
    secondRate: 'Times',
    resourcesFail: 'Resourcing Failure Processing',
    tabTitle: 'WMS supports delivery by assigned logistics',
    sourcingText: 'Please select sourcing failure processing',
    resourceIntervalText: 'Please enter resource interval',
    resourcesFailText: 'Please select resourcing failure processing',
  }
};
